export const drag_handle_color = () => (
  <path
    d="M9.5 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.5 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9.5 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.5 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M9.5 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.5 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
